// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d931af7b","237":"e46493ba","323":"466062f8","638":"c195d9df","646":"95e1a4b6","937":"2af0f9d5"}[chunkId] + ".chunk.js";
};